import type { EnvKpis } from "@/lib/types";

// A KPI that is absent or whose value is null is Unknown: a dash, never 0
// (Ingestion Matrix law). A reported 0 stays 0.
export function formatKpiValue(kpis: EnvKpis | null, key: keyof EnvKpis): string {
  const kpi = kpis?.[key];
  if (kpi == null || kpi.value == null) return "—";
  return kpi.value.toLocaleString();
}
